// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f821dd34","513":"6910e287","703":"5308463f","787":"c13886fd"}[chunkId] + ".chunk.js";
};